import {getGeometry, diameter, centroid} from "effects/midi/mappable/lang/geometry.js";
import {doc} from './documentation.js';
import {WIDTH, HEIGHT, PADDING} from 'components/effects/plane/constants.js';
import {getSlicedParameters, sliceParams} from './params.js';
import {updateObstacles} from './obstacles.js';
import {lazy} from './lazy.js';

const C_B =     0x0000;   /* This cell is an obstacle/boundary cell */
const B_N =     0x0001;   /* This obstacle cell has a fluid cell to the north */
const B_S =     0x0002;   /* This obstacle cell has a fluid cell to the south */
const B_W =     0x0004;   /* This obstacle cell has a fluid cell to the west */
const B_E =     0x0008;   /* This obstacle cell has a fluid cell to the east */
const B_NEW=     (B_N | B_W | B_E);
const B_SEW=     (B_S | B_W | B_E);
const B_NSE=     (B_N | B_S | B_E);
const B_NSW=     (B_N | B_S | B_W);
const B_NW=     (B_N | B_W);
const B_SW=     (B_S | B_W);
const B_NE=     (B_N | B_E);
const B_SE=     (B_S | B_E);
const B_NSEW =  (B_N | B_S | B_E | B_W);

const C_F =     0x0010;   /* This cell is a fluid cell */


doc(
    "navierStokes",
    {
        "parameters": "",
        "forceEmitters": "",
        "diffusionParam": "",
        "root": ""
    },
    "Navier stokes simulationn. force=array of force parameters"
);
export const navierStokes = (coordFunc, forceEmitters=[], diffusionParam=0.95, root=.5, resolution=64) => {
    let inserted_density=50;
    let diffusion = undefined;
    let iterations=6;
    let gridmodify=0;
    let fract=1/4;
    let dt=0.1;
    let dt0 = dt * resolution;
    let scaleX = resolution / WIDTH;
    let scaleY = resolution / HEIGHT;

    let rows = resolution+ 2;
    let arraySize = (resolution+2)*(resolution+2);
    let U = new Float32Array(arraySize);
    let V = new Float32Array(arraySize);
    let D          = new Float32Array(arraySize);

    let U_prev     = new Float32Array(arraySize);
    let V_prev     = new Float32Array(arraySize);
    let D_prev     = new Float32Array(arraySize);
    let NullArray  = new Float32Array(arraySize);
    // Precalculate lookup table for 2D > 1D array.

    let centerPos = (-0.5/resolution) * (1 + gridmodify);
    let scale = resolution * 0.5;
    let p5 = resolution + 0.5

    let IX = new Array(rows);
    for (var i = 0; i < rows; i++){
        IX[i] = new Array(rows);
        for (var b = 0; b < rows; b++){
            IX[i][b] = i+b*rows;
        }
    }

    // Init all Arrays.
    for (i = 0; i < arraySize; i++){
        D_prev[i] = U_prev[i] = V_prev[i] = D[i] = U[i] = V[i] = NullArray[i] = 0.0;
    }

    const clear = (_D=D, _U=U, _V=V) => {
        _D.set(NullArray);
        _U.set(NullArray);
        _V.set(NullArray);
    };

    const userAction = (pos=100, a=4, b=8, c=2) => {
        clear(D_prev, U_prev, V_prev);
        U[pos] = a;
        V[pos] = b;
        D[pos] = c;
        //callbackUser(D_prev, U_prev, V_prev, resolution);
    };

    const update = (pos,a,b,c) => {
        // Add user Action
        
        // Cals velosity & density
        vel_step(U, V, U_prev, V_prev, dt );
        dens_step(D, D_prev, U, V, dt );

        //callbackDisplay(D, U, V, resolution);
    };

    
    const vel_step = (u, v, u0,  v0, dt ) => {
        var tmp;
        
        add_source(u, u0, dt );
        add_source(v, v0, dt );
        
        tmp = u0;
        u0 = u;
        u = tmp;
        diffuse( 1, u, u0, dt );
        
        
        tmp = v0;
        v0 = v;
        v = tmp;
        diffuse( 2, v, v0, dt );
        
        project(u, v, u0, v0);
        
        tmp = u0;
        u0 = u;
        u = tmp;
        
        tmp = v0;
        v0 = v;
        v = tmp;
        advect(1, u, u0, u0, v0, dt);
        advect(2, v, v0, u0, v0, dt);
        
        project(u, v, u0, v0 );
    };

    const dens_step = (x, x0, u, v,  dt) => {
        var tmp;
        add_source (x, x0, dt);
        //SWAP ( x0, x );
        diffuse (0, x0, x,  dt );
        //SWAP ( x0, x );
        advect ( 0, x, x0, u, v, dt );
    };

    const add_source = (x, s, dt) => {
        for (var i=0; i<arraySize ; i++ ){
            x[i] += dt * s[i];
        }
    };

    const diffuse = (b,  x,  x0,  dt) => {
        for (var i=1; i < arraySize;i++){
            x[i] = x0[i]*diffusion;
        }
        set_bnd(b, x);
    };

    const project = ( u, v, p, div )  => {
        var prevRow, prevX, thisRow, nextValue, nextRow, to, lastRow, valueBefore, valueNext;
        for (let i = 1 ; i <= resolution; i++ ){
            prevRow   = IX[0][i-1];
            thisRow   = IX[0][i];
            nextRow   = IX[0][i+1];
            
            valueBefore  = thisRow - 1;
            valueNext    = thisRow + 1;
            
            to = resolution + valueNext;
            for (let k = valueNext; k < to; k++ ) {
                p[k] = 0;
                div[k] = (u[++valueNext] - u[++valueBefore] + v[++nextRow] - v[++prevRow]) * centerPos;
            }
        }
        
        set_bnd(0, div);
        set_bnd(0, p);
        
        for (let k=0 ; k<iterations; k++) {
            for (let j=1 ; j<=resolution; j++) {
                lastRow = IX[0][j-1];
                thisRow = IX[0][j];
                nextRow = IX[0][j+1];
                prevX = p[thisRow];
                thisRow++;
                for (i=1; i<=resolution; i++){
                    p[thisRow] = prevX = (div[thisRow] + p[++lastRow] + p[++thisRow] + p[++nextRow] + prevX ) * fract;
                }
            }
            set_bnd(0, p);
        }
        
        for (let j = 1; j <=  resolution; j++ ) {
            lastRow =  IX[0][j-1];
            thisRow =  IX[0][j];
            nextRow =  IX[0][j+1];
            
            valueBefore  = thisRow - 1;
            valueNext    = thisRow + 1;
            
            for (i = 1; i <=  resolution; i++) {
                u[++thisRow] -= scale * (p[++valueNext] - p[++valueBefore]);
                v[thisRow]   -= scale * (p[++nextRow]   - p[++lastRow]);
            }
        }
        set_bnd(1, u);
        set_bnd(2, v);
    };

    const advect = (b, d, d0, u, v, dt ) => {
        var to;
        for (var j = 1; j<= resolution; j++) {
            var pos = j * rows;
            for (var k = 1; k <= resolution; k++) {
                var x = k - dt0 * u[++pos];
                var y = j - dt0 * v[pos];
                
                if (x < 0.5) x = 0.5
                if (x > p5) x = p5;
                
                var i0 = x | 0;
                var i1 = i0 + 1;
                
                if (y < 0.5) y = 0.5
                if (y > p5) y = p5;
                
                var j0 = y | 0;
                var j1 = j0 + 1;
                var s1 = x - i0;
                var s0 = 1 - s1;
                var t1 = y - j0;
                var t0 = 1 - t1;
                var toR1 = IX[0][j0];
                var toR2 = IX[0][j1];
                d[pos] = s0 * (t0 * d0[i0 + toR1] + t1 * d0[i0 + toR2]) + s1 * (t0 * d0[i1 + toR1] + t1 * d0[i1 + toR2]);
            }
        }
        set_bnd(b, d);
    };

    // Calculate Boundary's
    const set_bnd = (b, x ) => {
        var i, j;
        switch (b){
        case 1 :
            for (i = 1; i <= resolution; i++) {
                x[i] =  x[i + rows];
                x[IX[i][(resolution+1)]] = x[IX[i][(resolution)]];
                x[IX[0][i]] = -x[IX[1][i]];
                x[IX[(resolution+1)][i]] = -x[IX[(resolution)][i]];
            }
            break;
        case 2 :
            for ( i = 1; i <= resolution; i++) {
                x[i] = -x[i + rows];
                x[IX[i][(resolution+1)]] = -x[IX[i][(resolution)]];
                x[IX[0][i]] =  x[IX[1][i]];
                x[IX[(resolution+1)][i]] =  x[IX[(resolution)][i]];
            }
            break;
        default :
            for ( i = 1; i <= resolution; i++) {
                x[i] =  x[i + rows];
                x[IX[i][(resolution+1)]] =   x[IX[i][(resolution)]];
                x[IX[0][i]] =   x[IX[1][i]];
                x[IX[(resolution+1)][i]] =   x[IX[(resolution)][i]];
            }
        }
        // Boundes of the Canvas
        var topPos = IX[0][resolution+1];
        x[0] = (x[1] + x[rows]) / 2;
        x[topPos] = (x[1 + topPos] + x[IX[resolution][0]]) / 2;
        x[(resolution+1)] = (x[resolution] + x[(resolution + 1) + rows]) / 2;
        x[(resolution+1)+topPos] = (x[resolution + topPos] + x[IX[resolution+1][resolution]]);

        /*
        let imax = 64;
        let jmax = 64;
        if (b <= 1) {
            for (i=1; i<=imax; i++) {
                for (j=1; j<=jmax; j++) {
                    if (flags[i][j+1] !== C_F) {
                        //console.log('flags[%s][%s] = ', i, j+1, flags[i][j+1]);
                    }
                    //if (flags[i][j] & B_NSEW) {
                    if (flags[i][j] === B_N) { 
                        //console.log("BN");
                        x[IX[i][j]]   = 0.0;
                        break;
                    } else if (flags[i][j] === B_E) { 
                        ////console//.log("BE");
                        x[IX[i][j]]   = -x[IX[i+1][j]];
                        break;
                    } else if (flags[i][j] === B_NE ) {
                        //console//.log("BNE");
                        x[IX[i][j]] = 0.0;
                        break;
                    }
                    else if (flags[i][j] === B_SE) {
                            //console.log("BSE");
                            x[IX[i][j]]   = -x[IX[i+1][j]];
                            break;
                    } else if (flags[i][j] === B_NW) {
                            //console.log("BNW");
                            x[IX[i][j]]   = 0.0;
                            break;
                    } else if (flags[i][j] === B_W) {
                            //console.log("BW");
                            x[IX[i][j]]   = -x[IX[i-1][j]];
                            break;
                    } else if (flags[i][j] === B_SW) {
                            //console.log("BSW");
                            x[IX[i][j]]   = -x[IX[i-1][j]];
                            break;
                    }
                    //}
	        }
            } 
        }

        if (b === 2) {
            for (i=1; i<=imax; i++) {
                for (j=0; j<=(jmax-1); j++) {
                    //if (flags[i][j+1] & B_NSEW) {
                    if (flags[i][j] === B_E) {
                            //console.log("BE2");
                            x[IX[i][j]] = -x[IX[i+1][j]];
                            break;
                    } else if (B_S===flags[i][j]) {
                            //console.log("BS2");
                            x[IX[i][j]] = 0.0;
                            break;
                    } else if (B_NE===flags[i][j]) {
                            //console.log("BNE 2");
                            x[IX[i][j]] = -x[IX[i+1][j]];
                            break;
                    } else if (B_SE===flags[i][j]) {
                            //console.log("BSE 2");
                            x[IX[i][j]] = 0.0;
                            break;
                    } else if (B_SW===flags[i][j]) {
                            //console.log("BSW 2");
                            x[IX[i][j]] = 0.0;
			    break;
                    } else if (B_W===flags[i][j]) {
                            //console.log("BW 2");
                            x[IX[i][j]] = -x[IX[i-1][j]];
                            break;
                    } else if (B_NW === flags[i][j]) {
                        //console.log("BNW 2");
                        x[IX[i][j]] = -x[IX[i-1][j]];
                        break;
                    }
                    //}
	        }
            } 
        }
        */
    };

    let mouseStart = undefined;
    let slicer = sliceParams();
    return (... args) => {
        let coords=args[0];
        let speed=args[1];
        diffusion = lazy(diffusionParam, ...args);
        coords = getSlicedParameters(slicer, coords, args.slice(1));

        let effect =args[6];
        effect.smokeResolution = resolution;
        effect.D = D;
        effect.IX = IX;
        let inputCoords = coordFunc && lazy(coordFunc, ...args);

        if (!inputCoords || Object.keys(inputCoords).length === 0) {
            mouseStart = undefined;
        } else {
            let _inputCoords = Object.keys(inputCoords).map(
                id => inputCoords[id])
                .filter(c => c);
            if (_inputCoords[0]) {
                let {x,y} = _inputCoords[0];
                if (!mouseStart) {
                    mouseStart = [x,y];
                }
                clear(D_prev, U_prev, V_prev);
                
                let dx = mouseStart[0] - x;
                let dy =  mouseStart[1] - y;
                var mousePathLength = Math.pow(dx * dx + dy * dy, lazy(root, ...args)) | 0;
                mousePathLength = (mousePathLength < 1) ? 1 : mousePathLength;
                for (i = 0; i < mousePathLength; i++) {
                    let _x = (((mouseStart[0] - (i / mousePathLength) * dx)) * scaleX) | 0;
                    let _y = (((mouseStart[1] - (i / mousePathLength) * dy)) * scaleY) | 0;
                    
                    pos = IX[_x][_y];
                    U[pos] = -dx / 6;
                    V[pos] = -dy / 6;
                    D[pos] = inserted_density;
                }
                
                mouseStart[0] = x;
                mouseStart[1] = y;
            }
        }

        for (let posDir of lazy(forceEmitters, ...args)) {
            let _x = lazy(posDir[0], ...args) * scaleX | 0;
            let _y = lazy(posDir[1], ...args) * scaleY | 0;
            var pos = IX[_x][resolution - _y];
            U[pos] = lazy(posDir[2], ...args);
            V[pos] = -1*lazy(posDir[3], ...args);
        }

        // updateObstacles(flags, macros, effect);
        update();


        let _coords = {};
        for (let id in coords) {
            let coord = coords[id];
            let {x,y} = coord;
            if (isNaN(x) || isNaN(y)) {
                continue;
            }

            // scale to the resolution
            let _x = Math.floor(x * resolution / (WIDTH - PADDING));
            let _y = Math.floor(y * resolution / (HEIGHT - PADDING));

            var posC = (_x + _y * resolution) * 4;
            var pos = IX[Math.min(_x, resolution)][Math.min(_y, resolution)];
            let xVel = U[pos];
            let yVel = V[pos];
            let densityFactor = coords[id].density || 1;
            _coords[id] = {
                ... coord,
                x:  x + 10*(speed/densityFactor)*xVel,
                y:  y + 10*(speed/densityFactor)*yVel,
            };
        }
      
        return _coords;
    };
};

